import React from 'react';
import PeprisDesktop from './PeprisDesktop';
import PeprisMobile from './PeprisMobile';

const Pepris = () => {
  const isMobile = window.innerWidth < 768;
  return isMobile ? <PeprisMobile /> : <PeprisDesktop />;
};

export { Pepris };